import React from "react";
import styled, { useTheme } from "styled-components";

interface NumberUnreadIndicatorProps {
  numberUnread: number;
}
const NumberUnread = styled.div`
  background-color: ${({ theme }) => theme.unreadIndicator.backgroundColor};
  color: ${({ theme }) => theme.unreadIndicator.fontColor};
  padding: 0 2px;
  font-size: ${({ theme }) => theme.fontSize.EXTRA_SMALL};
  font-weight: ${({ theme }) => theme.fontWeight.MEDIUM};
  line-height: 14px;
  text-align: center;
  border-radius: 2px;
  min-height: 14px;
  min-width: 12px;
`;

export const NumberUnreadIndicator: React.ComponentType<NumberUnreadIndicatorProps> =
  React.memo(function NumberUnreadIndicator({ numberUnread }) {
    return (
      <NumberUnread>{numberUnread < 100 ? numberUnread : `99+`}</NumberUnread>
    );
  });

const UnreadDot = styled.svg.attrs({
  viewBox: "0 0 6 6",
  xmlns: "http://www.w3.org/2000/svg",
})<{
  $isRead: boolean;
}>`
  width: 6px;
  height: 6px;
  color: ${({ theme }) => theme.intent.PRIMARY};
`;

interface UnreadIndicatorProps {
  isRead: boolean;
  className?: string;
}

export const UnreadIndicator: React.ComponentType<UnreadIndicatorProps> =
  React.memo(function UnreadIndicator({ className, isRead }) {
    const theme = useTheme();
    return (
      <UnreadDot $isRead={isRead} className={className}>
        {/* Circle to hide background */}
        <circle cx="3" cy="3" fill={theme.backgroundColor.DEFAULT} r="2.5" />
        <circle
          cx="3"
          cy="3"
          fill={isRead ? "transparent" : "currentColor"}
          fillOpacity={isRead ? 0 : 0.2}
          r="2.5"
          stroke="currentColor"
          strokeOpacity={isRead ? 0 : 1}
        />
      </UnreadDot>
    );
  });
